import __request__ from "routing/request";
export function authMetrics(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.cloud/auth_metrics", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
